import { AxiosError } from "axios";
import { IAgent } from "@edgetier/watchtower-types";
import { useAgent } from "./use-agent";
import { UseQueryOptions } from "react-query";

/**
 * Get an agent's first name.
 * @param agentId       The ID of the agent.
 * @param configuration React Query options.
 * @returns             React Query to get an agent's first name.
 */
export const useAgentFirstName = (agentId: string, configuration: UseQueryOptions<IAgent, AxiosError, string> = {}) => {
    return useAgent(agentId, { ...configuration, select: (agent) => agent.name.split(" ")[0] });
};
